/**
 * Traitements Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    traitements: [],
    traitement: {}
};

// Getters
const getters = {
    traitements: state => {
        return state.traitements
    },

    traitement: state => {
        return state.traitement
    }
};

// Actions
const actions = {
    getTraitements(context, payload) {
        function successCallback(response) {
            context.commit('getTraitementsHandler', { traitements: response.data.traitements });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Current.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getTraitement(context, payload) {
        function successCallback(response) {
            context.commit('getTraitementHandler', { traitement: response.data.traitement });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Current.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createTraitementActuel(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
// Liste des retours possibles
            // router.push({ name: 'medical-file', params: { file: response.data.dossier.slug }  });
            // router.push({ name: 'traitements' });
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            // router.back();
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Current.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    updateActuelTraitement(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            // router.push({ name: 'traitements' });
            // router.push({ name: 'medical-file', params: { file: response.data.dossier.slug }  });
            store.dispatch('findAndRemove', {name: 'treatment' });
            router.push({ name: 'treatment', params: { treatment: response.data.traitement.slug } });
            // router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.traitement.dossier.slug } }).href) +"#traitement");

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Current.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteActuelTraitement(context, payload) {
        function successCallback(response) {
            context.commit('getMedicalFileHandler', { file: response.data.dossier });
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Treatment.Current.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

};

// Mutations
const mutations = {
    getTraitementsHandler(state, { traitements }) {
        // Update traitements state
        state.traitements = traitements;
    },

    getTraitementHandler(state, { traitement }) {
        // Update traitement state
        state.traitement = traitement;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}